import Utils from "../utils/Utils";

const getAuth = ({ jwt, Authorization } = {}) => jwt || Authorization || "";

const vendorDashboardController = {
  getHealthDashboard: ({ jwt, Authorization } = {}) => {
    return Utils.controller(
      "api/dashboard/v1/gethealthDashboard",
      "",
      "GET",
      "",
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },

  getVendorDashboard: ({ jwt, Authorization, companyId } = {}) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);

    return Utils.controller(
      "api/dashboard/v1/getVendorDashboard",
      "",
      "GET",
      params.toString(),
      true,
      getAuth({ jwt, Authorization }),
      true,
    );
  },
};

export default vendorDashboardController;
